import { HelpCircle } from 'lucide-react';

import type { SalaryInsightsFaqItem } from '../types';

interface FaqSectionProps {
  faq: SalaryInsightsFaqItem[];
}

export function FaqSection({ faq }: FaqSectionProps) {
  return (
    <section className="bg-slate-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="mb-3 text-3xl font-bold text-slate-900 md:text-4xl">
            Frequently Asked Questions
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-slate-500">
            Common questions about salary ranges, skills, and how to negotiate better pay.
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2">
          {faq.map((item) => (
            <div
              key={item.question}
              className="rounded-2xl border border-slate-100 bg-white p-6 shadow-sm transition-shadow hover:shadow-md"
            >
              <div className="mb-3 flex items-start gap-3">
                <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#3bbdad]/10 text-[#3bbdad]">
                  <HelpCircle className="h-4 w-4" />
                </div>
                <h4 className="text-lg font-bold text-slate-900">{item.question}</h4>
              </div>
              <p
                className="pl-11 leading-relaxed text-slate-600"
                dangerouslySetInnerHTML={{ __html: item.answer }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
